import { ILatLng } from "polydraw";
import { IUserFeatures } from "../estate/key-info.model";
import { ICadastre } from "../search/estate-search-result.model";

export interface INavigationItem {
    address: string;
    cadastre: ICadastre;
    unitId: number;
    latlng: ILatLng;
    navigationType: NavigationType;
    userFeatures?: IUserFeatures;
}
export enum NavigationType {
    Estate,
    StockCooperativeShare,
    Commercial,
    NewDwelling,
}
